"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6852],{

/***/ 63543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34397);
/* harmony import */ var _ButtonStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2619);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);


var _excluded = ["styles", "children", "styleKey"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var ButtonComponent = function ButtonComponent(props) {
  var _props$styles = props.styles,
      styles = _props$styles === void 0 ? {} : _props$styles,
      children = props.children,
      _props$styleKey = props.styleKey,
      styleKey = _props$styleKey === void 0 ? "button" : _props$styleKey,
      rest = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);

  var block = styles.block,
      button = styles.button;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
    className: (0,aphrodite__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_ButtonStyle__WEBPACK_IMPORTED_MODULE_3__/* .ButtonStyle.block */ .Z.block, block),
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("button", _objectSpread(_objectSpread({
      className: (0,aphrodite__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_ButtonStyle__WEBPACK_IMPORTED_MODULE_3__/* .ButtonStyle */ .Z[styleKey], button)
    }, rest), {}, {
      children: children
    }))
  });
};

var Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ButtonComponent);

/***/ }),

/***/ 2619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ButtonStyle; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59499);
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34397);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58589);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88433);







var ButtonStyle = aphrodite__WEBPACK_IMPORTED_MODULE_0__/* .StyleSheet.create */ .mM.create({
  button: (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    position: "relative",
    fontSize: main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.mediumHeading */ .JB.mediumHeading,
    fontWeight: main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight.regular */ .Ue.regular,
    color: "white",
    backgroundColor: main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .accentColor.primaryColor */ .z.primaryColor,
    padding: "0 ".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom */ .D.atom),
    border: "none",
    borderRadius: main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_4__/* .borderRadius.normal */ .E.normal,
    margin: 0,
    width: "100%",
    minWidth: "64px",
    height: "40px",
    lineHeight: "40px",
    boxSizing: "border-box",
    overflow: "hidden",
    textAlign: "center",
    outline: "none",
    cursor: "pointer",
    textDecoration: "none",
    letterSpacing: "0.1em",
    transition: "background 0.4s ease, opacity 0.4s ease",
    ":hover": {
      backgroundColor: main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .accentColor.primaryDarkColor */ .z.primaryDarkColor
    },
    ":disabled": {
      opacity: 0.75
    }
  }, (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_5__/* .minResolution */ .UW)("scale2x"), {
    fontWeight: main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight.bold */ .Ue.bold
  }),
  buttonSmall: (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    fontSize: main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.subHeading */ .JB.subHeading,
    fontWeight: main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight.regular */ .Ue.regular,
    color: "white",
    backgroundColor: main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .accentColor.primaryColor */ .z.primaryColor,
    padding: "0 ".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom0_5x */ .D.atom0_5x),
    border: "none",
    borderRadius: main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_4__/* .borderRadius.normal */ .E.normal,
    margin: 0,
    width: "100%",
    minWidth: "64px",
    height: "40px",
    lineHeight: "40px",
    boxSizing: "border-box",
    overflow: "hidden",
    textAlign: "center",
    outline: "none",
    cursor: "pointer",
    textDecoration: "none",
    letterSpacing: "0.1em",
    transition: "background 0.4s ease, opacity 0.4s ease",
    ":hover": {
      backgroundColor: main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .accentColor.primaryDarkColor */ .z.primaryDarkColor
    },
    ":disabled": {
      opacity: 0.5
    }
  }, (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_5__/* .minResolution */ .UW)("scale2x"), {
    fontWeight: main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight.bold */ .Ue.bold
  }),
  buttonSecondary: {
    position: "relative",
    fontSize: main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.mediumHeading */ .JB.mediumHeading,
    fontWeight: main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight.regular */ .Ue.regular,
    color: main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .accentColor.primaryColor */ .z.primaryColor,
    backgroundColor: "#fff",
    padding: "0 ".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom */ .D.atom),
    border: "1px solid ".concat(main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .accentColor.primaryColor */ .z.primaryColor),
    borderRadius: main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_4__/* .borderRadius.normal */ .E.normal,
    margin: 0,
    width: "100%",
    minWidth: "64px",
    height: "40px",
    lineHeight: "38px",
    boxSizing: "border-box",
    overflow: "hidden",
    textAlign: "center",
    outline: "none",
    cursor: "pointer",
    textDecoration: "none",
    letterSpacing: "0.1em",
    display: "inline-block"
  },
  buttonSubmit: (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    position: "relative",
    fontSize: main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.mediumHeading */ .JB.mediumHeading,
    fontWeight: main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight.regular */ .Ue.regular,
    color: "white",
    backgroundColor: main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .accentColor.primaryColor */ .z.primaryColor,
    padding: "0 ".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom */ .D.atom),
    border: "none",
    borderRadius: main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_4__/* .borderRadius.normal */ .E.normal,
    margin: 0,
    width: "100%",
    minWidth: "64px",
    height: "54px",
    lineHeight: "54px",
    boxSizing: "border-box",
    overflow: "hidden",
    textAlign: "center",
    outline: "none",
    cursor: "pointer",
    textDecoration: "none",
    letterSpacing: "0.1em",
    transition: "background 0.4s ease, opacity 0.4s ease",
    ":before": {
      content: "''",
      border: "1px solid #fff",
      display: "block",
      borderRadius: "3px",
      position: "absolute",
      top: "50%",
      left: "50%",
      width: "calc(100% - ".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom */ .D.atom, ")"),
      height: "calc(100% - ".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom */ .D.atom, ")"),
      transform: "translate(-50%, -50%)",
      boxSizing: "border-box"
    },
    ":hover": {
      backgroundColor: main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .accentColor.primaryDarkColor */ .z.primaryDarkColor
    },
    ":disabled": {
      opacity: 0.5
    }
  }, (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_5__/* .minResolution */ .UW)("scale2x"), {
    fontWeight: main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight.bold */ .Ue.bold
  }),
  block: {
    padding: main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom */ .D.atom
  },
  loaderBlock: {
    left: "auto",
    right: "0.5rem",
    transform: "translate(0, -50%)"
  },
  buttonWithLoader: {
    padding: "0 1.2rem",
    position: "relative",
    minWidth: "80px",
    ":disabled": {
      opacity: 0.75
    }
  },
  text: {
    display: "inline-block",
    transition: "transform 0.4s ease"
  },
  textForLoading: {
    transform: "translateX(-1rem)"
  }
});

/***/ }),

/***/ 84220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_1__.z; }
/* harmony export */ });
/* harmony import */ var _ButtonStyle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2619);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63543);



/***/ }),

/***/ 91435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": function() { return /* binding */ defaultBlockStyle; },
/* harmony export */   "T8": function() { return /* binding */ enterDuration; },
/* harmony export */   "WG": function() { return /* binding */ defaultInnerStyle; },
/* harmony export */   "hj": function() { return /* binding */ transitionBlockStyles; },
/* harmony export */   "kX": function() { return /* binding */ exitDuration; },
/* harmony export */   "pS": function() { return /* binding */ ModalDialogWithCloseStyle; },
/* harmony export */   "tZ": function() { return /* binding */ transitionInnerStyles; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59499);
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34397);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58589);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88433);





var enterDuration = 400;
var exitDuration = 400;
var ModalDialogWithCloseStyle = aphrodite__WEBPACK_IMPORTED_MODULE_0__/* .StyleSheet.create */ .mM.create({
  block: {
    position: "fixed",
    top: 0,
    left: 0,
    backgroundColor: "rgba(40,40,40,0.2)",
    width: "100%",
    height: "100%",
    zIndex: 1000
  },
  inner: {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "90%",
    height: "100%",
    maxHeight: "80%",
    maxWidth: "540px",
    background: "#fff",
    borderRadius: main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_2__/* .borderRadius.normal */ .E.normal,
    boxShadow: "0 6px 30px rgba(40,40,40,0.1)",
    boxSizing: "border-box",
    willChange: "transform"
  },
  innerContent: (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    height: "calc(100% - 3rem)",
    marginTop: "3rem",
    overflowY: "auto",
    // "-webkitOverflowScrolling": "touch",
    padding: "0 ".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom2x */ .D.atom2x, " 2rem"),
    boxSizing: "border-box"
  }, (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__/* .moreThanBreakpoint */ .h6)("tablet"), {
    padding: "0 3rem 2rem"
  }),
  noInnerContentPadding: (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    padding: 0
  }, (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__/* .moreThanBreakpoint */ .h6)("tablet"), {
    padding: 0
  }),
  closeButton: {
    width: "3rem",
    height: "3rem",
    textAlign: "center",
    boxSizing: "border-box",
    fontSize: "24px",
    position: "absolute",
    top: 0,
    right: 0,
    cursor: "pointer",
    opacity: 0.5,
    transition: "all 0.3s ease",
    backfaceVisibility: "hidden",
    zIndex: 100,
    ":hover": {
      opacity: 1
    }
  },
  closeButtonIcon: {
    lineHeight: "3rem"
  }
});
var defaultBlockStyle = {
  transition: "all ".concat(enterDuration, "ms ease"),
  opacity: 0
};
var transitionBlockStyles = {
  entering: {
    opacity: 0
  },
  entered: {
    opacity: 1
  },
  exiting: {
    transition: "all ".concat(exitDuration, "ms ease")
  },
  exited: {
    opacity: 0,
    display: "none"
  }
};
var defaultInnerStyle = {
  transition: "all ".concat(enterDuration, "ms ease"),
  transform: "translate(-50%, -50%) scale(0.9)"
};
var transitionInnerStyles = {
  entering: {
    transform: "translate(-50%, -50%) scale(0.9)"
  },
  entered: {
    transform: "translate(-50%, -50%) scale(1)"
  },
  exiting: {
    transition: "all ".concat(exitDuration, "ms ease")
  },
  exited: {
    transform: "translate(-50%, -50%) scale(0.9)",
    display: "none"
  }
};

/***/ }),

/***/ 99717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ ModalDialogWithClose; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 1 modules
var Transition = __webpack_require__(98885);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Modal/ModalDialogWithClose/ModalDialogWithCloseStyle.ts
var ModalDialogWithCloseStyle = __webpack_require__(91435);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Icon/index.ts
var Icon = __webpack_require__(74303);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Modal/ModalDialogWithClose/ModalDialogWithClose.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var ModalDialogWithClose = function ModalDialogWithClose(props) {
  var _children = props.children,
      displayed = props.displayed,
      closeHandler = props.closeHandler,
      innerStyles = props.innerStyles,
      innerContentStyles = props.innerContentStyles,
      _props$styleKey = props.styleKey,
      styleKey = _props$styleKey === void 0 ? "default" : _props$styleKey,
      _props$styles = props.styles,
      styles = _props$styles === void 0 ? {} : _props$styles;
  var overlayStyle = styles.overlayStyle,
      innerStyle = styles.innerStyle,
      innerContentStyle = styles.innerContentStyle,
      closeButtonStyle = styles.closeButtonStyle,
      closeStyle = styles.closeStyle;
  var nodeRef = (0,react.useRef)(null);

  var onClickOverlay = function onClickOverlay(e) {
    if (!e.target.closest(".popupInner")) {
      closeHandler();
    }
  };

  var innerWidthStyle = (innerStyles === null || innerStyles === void 0 ? void 0 : innerStyles.width) && es/* StyleSheet.create */.mM.create({
    style: {
      width: innerStyles.width
    }
  });
  var innerMaxWidthStyle = (innerStyles === null || innerStyles === void 0 ? void 0 : innerStyles.maxWidth) && es/* StyleSheet.create */.mM.create({
    style: {
      maxWidth: innerStyles.maxWidth
    }
  });
  var innerHeightStyle = (innerStyles === null || innerStyles === void 0 ? void 0 : innerStyles.height) && es/* StyleSheet.create */.mM.create({
    style: {
      height: innerStyles.height
    }
  });
  var innerContentMarginStyle = (innerContentStyles === null || innerContentStyles === void 0 ? void 0 : innerContentStyles.marginTop) && es/* StyleSheet.create */.mM.create({
    style: {
      marginTop: innerContentStyles.marginTop,
      height: "calc(100% - ".concat(innerContentStyles.marginTop, ")")
    }
  });
  var innerContentPaddingStyle = styleKey !== "default" && ModalDialogWithCloseStyle/* ModalDialogWithCloseStyle */.pS[styleKey];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Transition/* default */.ZP, {
    timeout: {
      enter: ModalDialogWithCloseStyle/* enterDuration */.T8,
      exit: ModalDialogWithCloseStyle/* exitDuration */.kX
    },
    "in": displayed,
    unmountOnExit: true,
    nodeRef: nodeRef,
    children: function children(state) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        style: _objectSpread(_objectSpread({}, ModalDialogWithCloseStyle/* defaultBlockStyle */.Dt), ModalDialogWithCloseStyle/* transitionBlockStyles */.hj[state]),
        className: (0,es/* css */.iv)(ModalDialogWithCloseStyle/* ModalDialogWithCloseStyle.block */.pS.block, overlayStyle),
        onClick: onClickOverlay,
        ref: nodeRef,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          style: _objectSpread(_objectSpread({}, ModalDialogWithCloseStyle/* defaultInnerStyle */.WG), ModalDialogWithCloseStyle/* transitionInnerStyles */.tZ[state]),
          className: "".concat((0,es/* css */.iv)(ModalDialogWithCloseStyle/* ModalDialogWithCloseStyle.inner */.pS.inner, innerWidthStyle === null || innerWidthStyle === void 0 ? void 0 : innerWidthStyle.style, innerMaxWidthStyle === null || innerMaxWidthStyle === void 0 ? void 0 : innerMaxWidthStyle.style, innerHeightStyle === null || innerHeightStyle === void 0 ? void 0 : innerHeightStyle.style, innerStyle), " popupInner"),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: (0,es/* css */.iv)(ModalDialogWithCloseStyle/* ModalDialogWithCloseStyle.innerContent */.pS.innerContent, innerContentPaddingStyle, innerContentMarginStyle === null || innerContentMarginStyle === void 0 ? void 0 : innerContentMarginStyle.style, innerContentStyle),
            children: _children
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            onClick: closeHandler,
            className: (0,es/* css */.iv)(ModalDialogWithCloseStyle/* ModalDialogWithCloseStyle.closeButton */.pS.closeButton, closeButtonStyle),
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
              styleKey: "close",
              styles: [ModalDialogWithCloseStyle/* ModalDialogWithCloseStyle.closeButtonIcon */.pS.closeButtonIcon, closeStyle]
            })
          })]
        })
      });
    }
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Modal/ModalDialogWithClose/index.ts


/***/ }),

/***/ 33935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ CalendarDateBlock; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_components_form_Label__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35183);
/* harmony import */ var main_javascripts_components_form_InputError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44464);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58589);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var CalendarDateBlock = function CalendarDateBlock(props) {
  var name = props.name,
      namespace = props.namespace,
      label = props.label,
      date = props.date,
      isActive = props.isActive,
      error = props.error,
      _props$borderColorSty = props.borderColorStyleKey,
      borderColorStyleKey = _props$borderColorSty === void 0 ? "none" : _props$borderColorSty,
      _props$fontSizeStyleK = props.fontSizeStyleKey,
      fontSizeStyleKey = _props$fontSizeStyleK === void 0 ? "default" : _props$fontSizeStyleK;
  var errorStyles = error ? errorStyle : "";
  var placeholderStyles = date ? "" : placeholderStyle;
  var dateStyles = isActive ? dateActiveStyle : dateStyle; // TODO: InputErrorStyle

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    className: "calendar-date-block",
    ref: props.inputBlockRef,
    onClick: props.onClick,
    children: [label && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(main_javascripts_components_form_Label__WEBPACK_IMPORTED_MODULE_2__/* .Label */ ._, _objectSpread({}, label)), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
      css: [dateStyles, dateBorderColorStyle[borderColorStyleKey], dateFontSizeStyle[fontSizeStyleKey], errorStyles, placeholderStyles,  true ? "" : 0,  true ? "" : 0],
      children: date || "年 / 月 / 日"
    }), error && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(main_javascripts_components_form_InputError__WEBPACK_IMPORTED_MODULE_3__/* .InputError */ .p, {
      namespace: namespace,
      errorMessage: error.message,
      label: name
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("width:100%;padding:calc(", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, " - (", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_5__/* .lineHeight.body1 */ .Nv.body1, " - ", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_5__/* .fontSize.body */ .JB.body, ") / 2) ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, ";box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0); // const dateErrorStyle = css`
//   padding: ${space.atom0_5x} 0 0;
// `;

var dateStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_5__/* .fontSize.form */ .JB.form, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_5__/* .fontWeight.regular */ .Ue.regular, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_6__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";caret-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_6__/* .accentColor.primaryColor */ .z.primaryColor, ";padding:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom1_5x */ .D.atom1_5x, " 0;box-sizing:border-box;margin:0;width:100%;height:40px;line-height:40px;border:1px solid;border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_7__/* .borderRadius.normal */ .E.normal, ";background-color:#fff;appearance:none;cursor:pointer;" + ( true ? "" : 0),  true ? "" : 0);
var dateActiveStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)(dateStyle, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_6__/* .accentColor.primaryColor */ .z.primaryColor, ";border-bottom-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_6__/* .accentColor.primaryColor */ .z.primaryColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var errorStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("border-bottom-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_6__/* .accentColor.alertColor */ .z.alertColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var placeholderStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_6__/* .textColor.disabledColor */ .zP.disabledColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var dateBorderColorStyle = {
  none:  true ? {
    name: "1oscket",
    styles: "border-color:white"
  } : 0,
  primary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("border-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_6__/* .borderColor.primaryDarkColor */ .tv.primaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0),
  secondary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("border-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_6__/* .borderColor.secondaryLightColor */ .tv.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0)
};
var dateFontSizeStyle = {
  "default": /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_5__/* .fontSize.form */ .JB.form, ";" + ( true ? "" : 0),  true ? "" : 0),
  small: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_5__/* .fontSize.body */ .JB.body, ";" + ( true ? "" : 0),  true ? "" : 0)
};

/***/ }),

/***/ 30703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TH": function() { return /* binding */ CalendarStyle; },
  "hy": function() { return /* binding */ defaultStyle; },
  "T8": function() { return /* binding */ enterDuration; },
  "kX": function() { return /* binding */ exitDuration; },
  "vh": function() { return /* binding */ transitionStyles; }
});

// UNUSED EXPORTS: exitDelay

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
;// CONCATENATED MODULE: ./main/javascripts/styles/mixin/borderBoxStyle.ts
var borderBox = {
  "-webkit-box-sizing": "border-box",
  "-moz-box-sizing": "border-box",
  "-o-box-sizing": "border-box",
  "-ms-box-sizing": "border-box",
  "box-sizing": "border-box"
};
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/borderStyle.ts
var borderStyle = __webpack_require__(58589);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Calendar/CalendarStyle.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var arrowSize = "0.8rem";
var enterDuration = 360;
var exitDelay = 100;
var exitDuration = enterDuration + exitDelay;
var CalendarStyle = es/* StyleSheet.create */.mM.create({
  block: _objectSpread(_objectSpread({}, borderBox), {}, {
    width: "auto",
    maxWidth: "440px",
    minWidth: "min(calc(100vw - ".concat(spaceStyle/* space.atom2x */.D.atom2x, "), 300px)"),
    borderRadius: borderStyle/* borderRadius.normal */.E.normal,
    backgroundColor: "white",
    margin: "".concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom */.D.atom),
    position: "absolute",
    top: "88px",
    left: 0,
    zIndex: 10,
    boxShadow: "0 6px 30px rgba(40, 40, 40, 0.1)",
    ":before": {
      content: "''",
      position: "absolute",
      top: "calc(-".concat(arrowSize, " + 1px)"),
      display: "block",
      width: 0,
      height: 0,
      borderLeft: "".concat(arrowSize, " solid transparent"),
      borderRight: "".concat(arrowSize, " solid transparent"),
      borderBottom: "".concat(arrowSize, " solid white")
    }
  }),
  arrowLeft: {
    ":before": {
      left: "5%"
    }
  },
  arrowRight: {
    left: "auto",
    right: 0,
    ":before": {
      right: "5%"
    }
  },
  close: {
    color: colorStyle/* accentColor.primaryColor */.z.primaryColor,
    fontSize: typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading,
    position: "absolute",
    top: "17px",
    right: "7.143%",
    transform: "translateX(50%)",
    cursor: "pointer",
    padding: spaceStyle/* space.atom */.D.atom
  },
  entering: {
    opacity: 0,
    transform: "translateY(-16px)"
  },
  entered: {
    opacity: 1,
    transform: "translateY(0)"
  },
  exiting: {
    transition: "all ".concat(enterDuration, "ms ease 100ms")
  }
});
var defaultStyle = {
  transition: "all ".concat(enterDuration, "ms ease"),
  opacity: 0,
  transform: "translateY(-16px)",
  touchAction: "manipulation"
};
var transitionStyles = {
  entering: {
    opacity: 0,
    transform: "translateY(-16px)"
  },
  entered: {
    opacity: 1,
    transform: "translateY(0)"
  },
  exiting: {
    transition: "all ".concat(enterDuration, "ms ease ").concat(exitDelay, "ms")
  },
  exited: {
    display: "none"
  }
};

/***/ }),

/***/ 19484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ FullScreenModalDialog; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Modal/ModalDialogWithClose/index.ts + 1 modules
var ModalDialogWithClose = __webpack_require__(99717);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Modal/FullScreenModalDialog/FullScreenModalDialogStyle.ts



var FullScreenModalDialogStyle = es/* StyleSheet.create */.mM.create({
  inner: {
    backgroundColor: "#232323",
    width: "calc(100% + 1px)",
    height: "calc(100% + 1px)",
    maxWidth: "calc(100% + 1px)",
    maxHeight: "calc(100% + 1px)",
    boxShadow: "none",
    borderRadius: 0,
    paddingLeft: 0,
    paddingRight: 0
  },
  innerContent: (0,defineProperty/* default */.Z)({
    padding: 0,
    overflow: "hidden"
  }, (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), {
    padding: 0
  }),
  closeButton: {
    opacity: 1,
    ":hover": {
      opacity: 0.7
    }
  },
  close: {
    color: "#fff"
  },
  innerLight: {
    backgroundColor: "#fff",
    width: "calc(100% + 1px)",
    height: "calc(100% + 1px)",
    maxWidth: "calc(100% + 1px)",
    maxHeight: "calc(100% + 1px)",
    boxShadow: "none",
    borderRadius: 0,
    paddingLeft: 0,
    paddingRight: 0
  },
  closeLight: {
    color: "#232323"
  }
});
// EXTERNAL MODULE: ./main/javascripts/utils/ScrollUtil.ts
var ScrollUtil = __webpack_require__(75215);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Modal/FullScreenModalDialog/FullScreenModalDialog.tsx





var FullScreenModalDialog = function FullScreenModalDialog(props) {
  var children = props.children,
      header = props.header,
      displayed = props.displayed,
      closeHandler = props.closeHandler,
      colorMode = props.colorMode,
      _props$disableStopBod = props.disableStopBodyScrolling,
      disableStopBodyScrolling = _props$disableStopBod === void 0 ? false : _props$disableStopBod;
  (0,react.useEffect)(function () {
    if (!disableStopBodyScrolling) {
      (0,ScrollUtil/* stopBodyScrolling */.wV)(displayed);
    }
  }, [displayed]);
  (0,react.useEffect)(function () {
    return function () {
      if (!disableStopBodyScrolling) {
        (0,ScrollUtil/* stopBodyScrolling */.wV)(false);
      }
    };
  }, []);
  var innerStyle = FullScreenModalDialogStyle.inner;
  var closeStyle = FullScreenModalDialogStyle.close;
  var closeButtonStyle = FullScreenModalDialogStyle.closeButton;
  var innerContentStyle = FullScreenModalDialogStyle.innerContent;

  if (colorMode === "light") {
    innerStyle = FullScreenModalDialogStyle.innerLight;
    closeStyle = FullScreenModalDialogStyle.closeLight;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModalDialogWithClose/* ModalDialogWithClose */.T, {
    displayed: displayed,
    closeHandler: closeHandler,
    styles: {
      innerStyle: innerStyle,
      innerContentStyle: innerContentStyle,
      closeButtonStyle: closeButtonStyle,
      closeStyle: closeStyle
    },
    children: [header, children]
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Modal/FullScreenModalDialog/index.ts


/***/ }),

/***/ 12327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ GoogleTagManagerEventTypes; }
/* harmony export */ });
var GoogleTagManagerEventTypes = {
  destination: "destination",
  origin: "origin",
  itineraries: "itineraries",
  date: "date",
  hotelAvailabilities: "hotel_availabilities",
  flightAvailabilities: "flight_availabilities",
  dpAvailabilities: "dp_availabilities",
  lineAd: "line_ad",
  consultation: "consultation",
  flightSelection: "flight_selection",
  flightPreReservation: "flight_pre_reservation",
  dpPreReservation: "dp_pre_reservation",
  clickLineAd: "click_line_ad"
};

/***/ }),

/***/ 49224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ event; },
/* harmony export */   "EZ": function() { return /* binding */ flightPreReservationEvent; },
/* harmony export */   "GU": function() { return /* binding */ lineAdEvent; },
/* harmony export */   "QP": function() { return /* binding */ dpPreReservationEvent; },
/* harmony export */   "XC": function() { return /* binding */ consultationEvent; },
/* harmony export */   "Yy": function() { return /* binding */ dpAvailabilitiesEvent; },
/* harmony export */   "nt": function() { return /* binding */ flightSelectionEvent; },
/* harmony export */   "t6": function() { return /* binding */ flightAvailabilitiesEvent; },
/* harmony export */   "yb": function() { return /* binding */ hotelAvailabilitiesEvent; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12327);
/* harmony import */ var _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45021);
/* harmony import */ var main_javascripts_utils_cookieUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var event = function event(action, param) {
  window.dataLayer.push(_objectSpread({
    event: action
  }, param));
};
var hotelAvailabilitiesEvent = function hotelAvailabilitiesEvent(cacheId, params) {
  var adults = params.guests.reduce(function (acc, cur) {
    return acc + Number(cur.number_of_adult);
  }, 0);
  var agesOfChildren = params.guests.reduce(function (acc, cur) {
    if (cur.ages_of_children && cur.ages_of_children.length > 0) {
      return acc.concat(cur.ages_of_children);
    }

    return acc;
  }, []);
  event(_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_1__/* .GoogleTagManagerEventTypes.hotelAvailabilities */ .T.hotelAvailabilities, {
    destination_id: params.destination_id,
    destination_type: params.destination_type,
    destination: params.destination,
    start_date: params.checkin_date,
    end_date: params.checkout_date,
    adults: adults,
    ages_of_children: agesOfChildren,
    cache_id: cacheId
  });
};
var flightAvailabilitiesEvent = function flightAvailabilitiesEvent(cacheId, params) {
  var adults = params.traveler.number_of_adult;
  var agesOfChildren = params.traveler.ages_of_children || [];
  var startDate = params.departure_date;
  var endDate = params.return_date;

  if (params.flight_type === _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_2__/* .FlightTypes.multiCity */ .z.multiCity) {
    var _params$itineraries, _params$itineraries2;

    startDate = (_params$itineraries = params.itineraries) === null || _params$itineraries === void 0 ? void 0 : _params$itineraries[0].departure_date;

    if (((_params$itineraries2 = params.itineraries) === null || _params$itineraries2 === void 0 ? void 0 : _params$itineraries2.length) > 0) {
      endDate = params.itineraries[params.itineraries.length - 1].departure_date;
    }
  }

  event(_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_1__/* .GoogleTagManagerEventTypes.flightAvailabilities */ .T.flightAvailabilities, {
    destination_id: params.destination_id,
    destination_type: params.destination_type,
    destination: params.destination,
    origin_id: params.origin_id,
    origin_type: params.origin_type,
    origin: params.origin,
    start_date: startDate,
    end_date: endDate,
    itineraries: params.itineraries,
    flight_type: params.flight_type,
    cabin_class: params.cabin_class,
    adults: adults,
    ages_of_children: agesOfChildren,
    cache_id: cacheId
  });
};
var dpAvailabilitiesEvent = function dpAvailabilitiesEvent(cacheId, params) {
  var adults = params.guests.reduce(function (acc, cur) {
    return acc + Number(cur.number_of_adult);
  }, 0);
  var agesOfChildren = params.guests.reduce(function (acc, cur) {
    if (cur.ages_of_children && cur.ages_of_children.length > 0) {
      return acc.concat(cur.ages_of_children);
    }

    return acc;
  }, []);
  var startDate = params.departure_date;
  var endDate = params.return_date;
  event(_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_1__/* .GoogleTagManagerEventTypes.dpAvailabilities */ .T.dpAvailabilities, {
    destination_id: params.destination_id,
    destination_type: params.destination_type,
    destination: params.destination,
    origin_id: params.origin_id,
    origin_type: params.origin_type,
    origin: params.origin,
    start_date: startDate,
    end_date: endDate,
    flight_type: params.flight_type,
    cabin_class: params.cabin_class,
    adults: adults,
    ages_of_children: agesOfChildren,
    cache_id: cacheId
  });
};

var line_ad_value = function line_ad_value() {
  return Number((0,main_javascripts_utils_cookieUtil__WEBPACK_IMPORTED_MODULE_3__/* .getCookie */ .e)("line_registration_value") || 500);
};

var lineAdEvent = function lineAdEvent() {
  var value = line_ad_value();
  var currency = (0,main_javascripts_utils_cookieUtil__WEBPACK_IMPORTED_MODULE_3__/* .getCookie */ .e)("currency") || "JPY";
  event(_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_1__/* .GoogleTagManagerEventTypes.lineAd */ .T.lineAd, {
    yahoo_conversion_value: value,
    value: value,
    currency: currency
  });
};
var consultationEvent = function consultationEvent() {
  var isMail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var value = isMail ? 2000 : 1000;
  var currency = (0,main_javascripts_utils_cookieUtil__WEBPACK_IMPORTED_MODULE_3__/* .getCookie */ .e)("currency") || "JPY"; // const value = line_ad_value() * scale;

  event(_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_1__/* .GoogleTagManagerEventTypes.consultation */ .T.consultation, {
    yahoo_conversion_value: value,
    value: value,
    currency: currency
  });
};
var flightSelectionEvent = function flightSelectionEvent() {
  event(_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_1__/* .GoogleTagManagerEventTypes.flightSelection */ .T.flightSelection, {});
};
var flightPreReservationEvent = function flightPreReservationEvent() {
  var value = Number((0,main_javascripts_utils_cookieUtil__WEBPACK_IMPORTED_MODULE_3__/* .getCookie */ .e)("reservation_form_landing_value") || 50);
  var currency = (0,main_javascripts_utils_cookieUtil__WEBPACK_IMPORTED_MODULE_3__/* .getCookie */ .e)("currency") || "JPY";
  event(_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_1__/* .GoogleTagManagerEventTypes.flightPreReservation */ .T.flightPreReservation, {
    yahoo_conversion_value: value,
    value: value,
    currency: currency
  });
};
var dpPreReservationEvent = function dpPreReservationEvent() {
  var value = Number((0,main_javascripts_utils_cookieUtil__WEBPACK_IMPORTED_MODULE_3__/* .getCookie */ .e)("reservation_form_landing_value") || 50);
  var currency = (0,main_javascripts_utils_cookieUtil__WEBPACK_IMPORTED_MODULE_3__/* .getCookie */ .e)("currency") || "JPY";
  event(_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_1__/* .GoogleTagManagerEventTypes.dpPreReservation */ .T.dpPreReservation, {
    yahoo_conversion_value: value,
    value: value,
    currency: currency
  });
};

/***/ })

}]);